import PropTypes from 'prop-types'
import React, { useRef } from 'react'
import styled, { theme, prop } from '@nobia/zeus-components/lib/styled'

import OutsideAlerter from '../outsideClickHandler/OutsideClickHandler'
import { Icon } from '../icons'

const Wrapper = styled.div`
  position: absolute;
  top: 40px;
  bottom: 40px;
  left: 20px;
  right: 20px;
  background-color: ${p => p.theme.tooltip.bgColor};
  color: ${p => p.theme.tooltip.color};
  padding: 30px;
  border-radius: 12px;
  z-index: ${p => p.zIndex || 10};
  bottom: auto;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  @media (min-width: ${prop('theme.body.tabletWidth')}) {
    margin-left: auto;
    margin-right: auto; 
    width: 300px;
  }
`

const Close = styled.button`
  position: absolute;
  top: 10px;
  right: 0;
  font-size: 40px;
  font-weight: 300;
  color: ${theme('colors.white')};
  cursor: pointer;
  @media (min-width: ${prop('theme.body.tabletWidth')}) {
    right: 10px;
  }
`
const H3 = styled.h3`
  margin: 10px 0;
  color: ${theme('colors.white')};
  font-size: ${p => p.theme.tooltip.fontSize};
`
const P = styled.p`
  margin: 10px 0;
`
const A = styled.a`
  color: inherit;
`

const format = text => {

  

  const linkUrl = text.match(/\]\((.*?)\)/)
  const splitText = text.split(/\[(.*)\]\(.*\)/)
  if (linkUrl) {
    return [
      splitText[0],
      <A href={linkUrl[1]} target="_blank">
        {splitText[1]}
      </A>,
      splitText[2],
    ]
  }
  return text
}

const Tooltip = ({title, description, onClose}) => {

  const tooltipRef = useRef(null);
  const width = 25;
  const height = 26;

  return (
    <OutsideAlerter ref={tooltipRef} onClose={onClose}>
      <Wrapper zIndex={12}>
        <Close onClick={onClose} tabIndex="1">
          &times;
        </Close>
        <Icon name="info" width={width} height={height} />
        <H3>{title}</H3>
        {description && description.map(p => <P>{format(p)}</P>)}
      </Wrapper>
    </OutsideAlerter>
  )
}

Tooltip.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default Tooltip

// public static string ReplaceLinks(string arg)
// //Replaces web and email addresses in text with hyperlinks

// {
//     Regex urlregex = new Regex(@"(^|[\n ])(?<url>(www|ftp)\.[^ ,""\s<]*)", RegexOptions.IgnoreCase | RegexOptions.Compiled);
//     arg = urlregex.Replace(arg, " <a href=\"http://${url}\" target=\"_blank\">${url}</a>");
//     Regex httpurlregex = new Regex(@"(^|[\n ])(?<url>(http://www\.|http://|https://)[^ ,""\s<]*)", RegexOptions.IgnoreCase | RegexOptions.Compiled);
//     arg = httpurlregex.Replace(arg, " <a href=\"${url}\" target=\"_blank\">${url}</a>");
//     Regex emailregex = new Regex(@"(?<url>[a-zA-Z_0-9.-]+\@[a-zA-Z_0-9.-]+\.\w+\s)", RegexOptions.IgnoreCase | RegexOptions.Compiled);
//     arg = emailregex.Replace(arg, " <a href=\"mailto:${url}\">${url}</a> ");
//     return arg;
// }
